<section class="main">
    <div class="container">
        <article class="astro-registration-form">
            <div class="col-lg-12 col-md-6 col-sm-12">
                <div class="row">
                    <div class="col-lg-12">
                        <h2>Fill Basic Details</h2>
                    </div>
                </div>
                <form [formGroup]="astrologerRegForm" (ngSubmit)="onSubmit()">
                    <div class="row justify-content-center">
                        <div class="col-lg-6 col-md-6 col-sm-6 mb-3">
                            <label for="emailAddress" class="form-label">Email ID&nbsp;<span
                                    class="color-red">*</span></label>
                            <input type="text" class="form-control" id="emailAddress" formControlName="emailAddress"
                                placeholder="Enter Email Id" [class.is-invalid]="
    astrologerRegForm.get('emailAddress')?.invalid &&
    astrologerRegForm.get('emailAddress')?.touched
  " />
                            <div class="invalid-feedback" *ngIf="
       astrologerRegForm.get('emailAddress')?.errors?.['required'] &&
       astrologerRegForm.get('emailAddress')?.touched
     ">
                                Email is required.
                            </div>

                            <div class="invalid-feedback" *ngIf="
       astrologerRegForm.get('emailAddress')?.errors?.['email'] &&
       astrologerRegForm.get('emailAddress')?.touched
     ">
                                Enter a valid email address.
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-6 mb-3">
                            <label for="astrologerName" class="form-label">Your full name&nbsp;<span
                                    class="color-red">*</span></label>
                            <input type="text" class="form-control" id="astrologerName" formControlName="astrologerName"
                                placeholder="Enter your full name" [class.is-invalid]="
    astrologerRegForm.get('astrologerName')?.invalid &&
    astrologerRegForm.get('astrologerName')?.touched
  " />
                            <div class="invalid-feedback" *ngIf="
       astrologerRegForm.get('astrologerName')?.errors?.['required'] &&
       astrologerRegForm.get('astrologerName')?.touched
     ">
                                Full name is required.
                            </div>
                        </div>
                        <div class="col-lg-6 col-md-6 col-sm-6 mb-3">
                            <label for="mobile" class="form-label">Mobile No.&nbsp;<span
                                    class="color-red">*</span></label>
                            <div class="select_opt">
                                <ngx-intl-tel-input [cssClass]="'form-control'" [preferredCountries]="['in', 'us']"
                                    [enableAutoCountrySelect]="true" [enablePlaceholder]="true" [maxLength]="10"
                                    [customPlaceholder]="'Enter Mobile Number'" [searchCountryFlag]="true"
                                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                    [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India"
                                    [phoneValidation]="true" [separateDialCode]="true" formControlName="mobileNumber"
                                    [ngClass]="{
    'is-invalid':
      astrologerRegForm.get('mobileNumber')?.invalid &&
      astrologerRegForm.get('mobileNumber')?.touched
  }">
                                </ngx-intl-tel-input>
                            </div>
                            <div class="invalid-feedback d-block" *ngIf="
       astrologerRegForm.get('mobileNumber')?.errors?.['required'] &&
       astrologerRegForm.get('mobileNumber')?.touched
     ">
                                Mobile number is required.
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-6 mb-3">
                            <label for="alternateMobileNumber" class="form-label">Alternate Mobile
                                No.</label>
                            <div class="select_opt">
                                <ngx-intl-tel-input [cssClass]="'form-control'" [preferredCountries]="['in', 'us']"
                                    [enableAutoCountrySelect]="true" [enablePlaceholder]="true"
                                    [customPlaceholder]="'Enter Alternate Mobile Number'" [searchCountryFlag]="true"
                                    [maxLength]="10"
                                    [searchCountryField]="[SearchCountryField.Iso2, SearchCountryField.Name]"
                                    [selectFirstCountry]="false" [selectedCountryISO]="CountryISO.India"
                                    [phoneValidation]="true" [separateDialCode]="true"
                                    formControlName="alternateMobileNumber">
                                </ngx-intl-tel-input>
                            </div>
                            <div id="mobileno" class="form-text"> </div>
                        </div>
                        <div class="col-lg-12 col-md-12 col-sm-12 mb-3">
                            <label for="about" class="form-label">
                                About Me (Write a short bio about you )
                            </label>
                            <textarea name="about" formControlName="aboutMe" class="form-control" id="about" cols="10"
                                rows="20" placeholder="Eg.I am a lawyer having expertise, practising since 2019...."
                                [ngClass]="{'is-invalid': astrologerRegForm.get('aboutMe')?.invalid &&
            astrologerRegForm.get('aboutMe')?.touched }"></textarea>
                            <div class="invalid-feedback" *ngIf="
          astrologerRegForm.get('aboutMe')?.errors?.['required'] &&
          astrologerRegForm.get('aboutMe')?.touched">
                                About Me is required.
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-6 col-md-12 col-sm-12 mb-3">
                            <label for="experience">Experience as an Expert Lawyer</label>
                            <input type="number" class="form-control" id="experience" formControlName="workExperince"
                                placeholder="Experience in Years" [class.is-invalid]="
    astrologerRegForm.get('workExperince')?.invalid &&
    astrologerRegForm.get('workExperince')?.touched
  " />
                            <button class="years">years</button>
                            <div class="invalid-feedback" *ngIf="
       astrologerRegForm.get('workExperince')?.errors?.['required'] &&
       astrologerRegForm.get('workExperince')?.touched
     ">
                                Experience is required.
                            </div>
                        </div>

                        <div class="col-lg-6 col-md-12 col-sm-12 mb-3">
                            <label for="experience">Select Gender</label>
                            <select name="" class="form-control" id="" formControlName="gender">
                                <option value="MALE">
                                    Male
                                </option>
                                <option value="FEMALE">
                                    Female
                                </option>
                            </select>
                            <div class="invalid-feedback" *ngIf="
       astrologerRegForm.get('gender')?.errors?.['required'] &&
       astrologerRegForm.get('gender')?.touched
     ">
                                Gender is required.
                            </div>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-6 col-md-12 col-sm-12 mb-3 exp">

                            <a href="javascript:void();" class="dropdown-toggle" type="button" id="dropdownMenuButton1"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                <label for="expertise" class="cpointer">Expertise in (choose upto 3)</label>
                            </a>
                            <form action="">
                                <ul class="dropdown-menu formDropdown" aria-labelledby="dropdownMenuButton1">
                                    <!-- <div class="srchAutoCertificate or Award">
                                                <input name="searchSkills"
                                                 type="text"  [(ngModel)]="searchExpertise"
                                                        placeholder="Search" class=" p-2 mb-0">
                                        </div> -->

                                    <div class="scroltop">
                                        <li *ngFor="let item of expetiseList"
                                            class="d-flex align-items-center cursorPointer "
                                            (click)="selectExpertise(item.expertiseArea)">
                                            {{item.expertiseArea}}
                                        </li>
                                    </div>

                                </ul>
                            </form>

                            <!-- <select id="expertise" name="expertise" class="form-control" >
                                <option value="">
                                    Select Expertise
                                </option>
                                <option  *ngFor="let item of expetiseList" (click)="selectExpertise(item)">
                                    {{item?.expertiseArea}}</option>
                            </select> -->
                            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13"
                            fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                            <path
                                d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                        </svg> -->
                            <div class="astro-options">
                                <span class="vedic" *ngFor="let item of selectedExertise; let i =index">{{item}}<img
                                        src="../assets/images/close-vector.svg" class="deleteExp"
                                        (click)="deleteExpertise(item,i)" alt=""></span>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-lg-6 col-md-12 col-sm-12 mb-3 lang">
                            <a href="javascript:void();" class="dropdown-toggle" type="button" id="dropdownMenuButton1"
                                data-bs-toggle="dropdown" aria-expanded="false">
                                <label for="expertise" class="cpointer">Proficiency in Language</label>
                            </a>
                            <form action="">
                                <ul class="dropdown-menu formDropdown" aria-labelledby="dropdownMenuButton1">
                                    <!-- <div class="srchAutoCertificate or Award">
                                                <input name="searchSkills"
                                                 type="text"  [(ngModel)]="searchExpertise"
                                                        placeholder="Search" class=" p-2 mb-0">
                                        </div> -->

                                    <div class="scroltop">
                                        <li *ngFor="let item of knownLanguage"
                                            class="d-flex align-items-center cursorPointer "
                                            (click)="selectKnownLanguage(item.knownLanguage)">
                                            {{item.knownLanguage}}
                                        </li>
                                    </div>

                                </ul>
                            </form>

                            <!-- <select id="expertise" name="expertise" class="form-control" >
                                <option value="">
                                    Select Expertise
                                </option>
                                <option  *ngFor="let item of expetiseList" (click)="selectExpertise(item)">
                                    {{item?.expertiseArea}}</option>
                            </select> -->
                            <!-- <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13"
                            fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
                            <path
                                d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                        </svg> -->
                            <div class="astro-options">
                                <span class="vedic" *ngFor="let item of selectedLanguage; let i =index">{{item}}<img
                                        src="../assets/images/close-vector.svg" class="deleteExp"
                                        (click)="deleteSelectedLanguage(item,i)" alt=""></span>
                            </div>
                        </div>
                    </div>


                    <!-- <div class="row">
                        <div class="col-lg-6 col-md-12 col-sm-12 mb-3">
                            <label for="work-with-otherplatform">Have you worked with any other astrology platform?</label>
                            <div class="work-with-otherplatform">
                                <input type="radio" name="experience" id="yes" value="yes" checked>
                                <label for="yes" class="yes">Yes</label>
                                <input type="radio" name="experience" id="no" value="no">
                                <label for="no" class="no">No</label>
                            </div>
                        </div>
                    </div> -->

                    <div class="row">
                        <div class="col-lg-4 col-md-6 col-sm-12 mb-3 upload_img">
                            <label>Upload your photo</label><br>
                            <input type="file" #fileInput accept="image/*" class="form-control"
                                (change)="onFileChange($event)" hidden>
                            <span class="img-uploads" *ngIf="!imagePreview" (click)="fileInput.click()">
                                <p>Click to choose photo
                                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor"
                                        class="bi bi-plus-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                        <path
                                            d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4" />
                                    </svg>
                                </p>
                            </span>
                            <div *ngIf="imagePreview" class="image-wrapper">
                                <div class="image_box">
                                    <img class="imgProfile" [src]="imagePreview" alt="Profile" (click)="openPreview()">
                                    <img class="profileDelete" src="../assets/images/close-vector.svg" alt="Delete"
                                        (click)="deleteProfile(fileInput)">
                                </div>
                            </div>
                        </div>
                        <div *ngIf="showPreview" class="image-overlay" (click)="closePreview()">
                            <img [src]="imagePreview" class="full-image">
                        </div>

                    </div>

                    <div class="row">
                        <div class="col-lg-4 col-md-4 col-sm-6">
                            <button type="submit" [disabled]="!astrologerRegForm.valid" class="btn btn-primary reg-btn">
                                Submit
                            </button>
                        </div>
                    </div>

                </form>
            </div>
        </article>
    </div>
</section>

<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <img src="/assets/image/submit.svg" alt="">
            </div>
            <div class="modal-body">
                <h2>Your basic details are submitted.</h2>
                <p>Once admin approves your profile, you will get a notification for interview on your email id.
                    It usually takes upto 5 working days.</p>
            </div>
        </div>
    </div>
</div>